import { getChatSchema } from "@corca/tiptap";
import { yXmlFragmentToProseMirrorRootNode } from "@tiptap/y-tiptap";
import * as Y from "yjs";

import { base64toUint8Array } from "@/utils/base64/base64toUint8Array";

export function extractMessageBodyText(base64: string | null): string {
  if (!base64) return "";

  try {
    const yDoc = new Y.Doc();
    Y.applyUpdate(yDoc, base64toUint8Array(base64));
    const fragment = yDoc.getXmlFragment("textNode");
    const pmNode = yXmlFragmentToProseMirrorRootNode(fragment, getChatSchema());
    return pmNode.textContent.trim();
  } catch {
    return "";
  }
}
